import React, { Component } from "react";
import { withApollo } from "react-apollo";
import gql from "graphql-tag";
import Cookies from "universal-cookie";

const cookies = new Cookies();

const kontakti = gql`
query kontakti {
  page(id: "cGFnZToxMzI=") {
    id
    title
    kontakti {
      colLeft
      colMiddle
      colRight
      socialTitle
      socialIcons {
        url
        icon {
          sourceUrl
        }
      }
    }
    translation(language: EN) {
      title
      kontakti {
        colLeft
        colMiddle
        colRight
        socialIcons {
          url
          icon {
            sourceUrl
          }
        }
        socialTitle
      }
    }
  }
}
`;
class Kontakti extends Component {
  state = {
    dataq: []
  };

  componentDidMount() {
    this.executeKontakti();
  }
  executeKontakti = async () => {
    const { client } = this.props;
    const props = await client.query({
      query: kontakti
    });
    //console.log(props);
    if (!props.data.page) {
      return <p>...</p>;
    }
    const dataq = (
      <div  id = "kontakti"
      data-headertitle = {
          cookies.get("lang") === "LV" ? "Kontakti" : cookies.get("lang") === "EN" ? "Contacts" : null
                }>
        <div className="container single-content-text">
          <h2 className="mb-4">
            {cookies.get("lang") === "LV" &&
                        props.data.page.title}
                      {cookies.get("lang") === "EN" &&
                        props.data.page.translation.title}</h2>
          <div className="row">
            <div className="col-12">
              <div className="embed-container mb-5">
                <iframe
                  title="embediframe"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2175.464385798331!2d24.11672601626045!3d56.95797740586472!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eecfceea583c69%3A0x8df10bccdce00422!2sKa%C5%86epes%20Kult%C5%ABras%20centrs!5e0!3m2!1sen!2slv!4v1581263068487!5m2!1sen!2slv"
                  width="600"
                  height="450"
                  frameBorder="0"
                  allowFullScreen=""
                ></iframe>
              </div>
            </div>
            </div>
              <div className="kontaktiTitle">
                <div className="row">
                  <div className="col-12 col-md-4">
                    {cookies.get("lang") === "LV" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.data.page.kontakti.colLeft
                        }}
                      />
                    )}
                    {cookies.get("lang") === "EN" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            props.data.page.translation.kontakti.colLeft
                        }}
                      />
                    )}
                  </div>
                  <div className="col-12 col-md-4">
                    {cookies.get("lang") === "LV" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.data.page.kontakti.colMiddle
                        }}
                      />
                    )}
                    {cookies.get("lang") === "EN" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            props.data.page.translation.kontakti.colMiddle
                        }}
                      />
                    )}
                  </div>
                  <div className="col-12 col-md-4">
                    {cookies.get("lang") === "LV" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: props.data.page.kontakti.colRight
                        }}
                      />
                    )}
                    {cookies.get("lang") === "EN" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            props.data.page.translation.kontakti.colRight
                        }}
                      />
                )}
                <p><strong>{cookies.get("lang") === "LV" && (props.data.page.kontakti.socialTitle)}
                    {cookies.get("lang") === "EN" && (props.data.page.translation.kontakti.socialTitle)}</strong></p><p>
                {
                  props.data.page.kontakti.socialIcons &&
                  props.data.page.kontakti.socialIcons.map((match,i) => (
                    <a href = {
                      match.url
                    }
                    className = "socialLink"
                    rel = "noopener noreferrer"
                    target = "_blank"
                    key = {
                      i
                    } > < img src = {
                      match.icon.sourceUrl
                    }
                    alt = {
                      match.url
                    }
                    /></a >
                  ))}
                </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
    );
    this.setState({ dataq });
  };

  render() {
    //console.log(props.data.page.galerija);
    const { dataq } = this.state;
    return <React.Fragment>{dataq}</React.Fragment>;
  }
}
export default withApollo(Kontakti);
